// Qué portada toca. Un solo sitio donde se decide, para que no acabe repartido
// entre el router, el sidebar y la propia portada.
//
// La regla mira lo que el usuario NO abre, no lo que abre: alguien de logística
// que además tenga ventas o producción es un usuario normal con una pantalla
// más, y lo que necesita al entrar es la portada general. La portada de
// logística es para quien SÓLO hace logística.
//
// Mientras no se sabe no se decide: pintar la general y cambiarla medio segundo
// después es un parpadeo, y pintar la de logística a quien no lo es, un susto.
import { useModulos } from '@/hooks/useModulos'
import DashboardV2Page from '@/pages/DashboardV2Page'
import { InicioLogisticaPage } from '@/pages/InicioLogisticaPage'

export function InicioPage() {
  const { puede, cargando } = useModulos()
  if (cargando) return null
  if (puede('logistica') && !puede('ventas') && !puede('produccion')) {
    return <InicioLogisticaPage />
  }
  return <DashboardV2Page />
}
